var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-breadcrumbs',{attrs:{"items":_vm.items}}),_c('v-divider'),_c('add-new-agency',{staticClass:"mt-5",attrs:{"single_agency":_vm.single_agency},on:{"create":function($event){return _vm.createAgency($event)},"update":function($event){return _vm.update_Agency($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }